// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;Enter his gates with thanksgiving<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and his courts with praise;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;give thanks to him and bless his name.<br> </p> </div></div>";
// Exports
module.exports = code;